import { ChevronLeft, ChevronRight } from 'lucide-react';
import { RtlIcon } from '@/components/ui/rtl-icon';
import { useTranslation } from 'react-i18next';

interface TablePaginationProps {
  currentPage: number;
  totalPages: number;
  totalRecords: number;
  visibleCount: number;
  onPageChange: (page: number) => void;
}

export function TablePagination({
  currentPage,
  totalPages,
  totalRecords,
  visibleCount,
  onPageChange,
}: TablePaginationProps) {
  const { t } = useTranslation();
  return (
    <div className='flex items-center justify-center sm:justify-end gap-4 px-4 py-4'>
      <span className='text-sm text-sd-muted-foreground'>
        {t('show_records', { visible: visibleCount, total: totalRecords })}
      </span>
      <div className='flex items-center gap-1'>
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          className='rounded-lg p-1.5 transition-colors hover:bg-sd-muted'
        >
          <RtlIcon>
            <ChevronLeft className='h-4 w-4' />
          </RtlIcon>
        </button>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`flex h-8 w-8 items-center justify-center rounded-lg text-sm transition-colors ${
              page === currentPage
                ? 'bg-sd-primary font-semibold text-sd-primary-foreground'
                : 'hover:bg-sd-muted'
            }`}
          >
            {page}
          </button>
        ))}
        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          className='rounded-lg p-1.5 transition-colors hover:bg-sd-muted'
        >
          <RtlIcon>
            <ChevronRight className='h-4 w-4' />
          </RtlIcon>
        </button>
      </div>
    </div>
  );
}
